import React, { createContext, useContext, useState, useEffect } from "react";

export const translations = {
  tr: {
    nav: {
      home: "Anasayfa",
      about: "Kurumsal",
      services: "Faaliyet Alanları",
      portfolio: "Projeler",
      whyus: "Değerlerimiz",
      contact: "İletişim",
      adminLogin: "Yönetici Girişi",
    },
    hero: {
      overline: "DEMİRAY İNŞAAT — DEMIRAY CONSTRUCTION",
      title: "Yarınlara Değer\nKatan Projeler",
      subtitle:
        "Her projemizde kaliteyi, estetiği ve işlevselliği ön planda tutuyoruz. Güçlü altyapı, rafine tasarım ve fonksiyonelliğin kusursuz uyumu.",
      cta: "Projelerimizi İnceleyin",
      ctaSecondary: "Bize Ulaşın",
    },
    about: {
      overline: "KURUMSAL",
      title: "Estetik ve Dayanıklılığı Buluşturuyoruz",
      body:
        "Demiray İnşaat olarak, sektördeki tecrübemizi güven, kalite ve sürdürülebilirlik ilkeleriyle birleştirerek yaşam alanları inşa ediyoruz. Kurulduğumuz günden bu yana müşteri memnuniyetini ve mühendislik kalitesini ön planda tutarak, yenilikçi projelere imza atıyor ve her bir yapıya değer katıyoruz.",
      body2:
        "Güçlü teknik kadromuz, çözüm odaklı yaklaşımımız ve etik çalışma prensiplerimizle, inşaat sektöründe güvenilir bir marka olmanın gururunu yaşıyoruz.",
      visionTitle: "Vizyon",
      vision:
        "İnşaat sektöründe kalite, güven ve sürdürülebilirliği esas alan lider bir marka olmak. Teknolojiyi ve yenilikleri projelerimize entegre ederek, yaşanabilir ve estetik yaşam alanları sunmak.",
      missionTitle: "Misyon",
      mission:
        "Müşterilerimizin ihtiyaçlarına uygun, kaliteli ve zamanında teslim edilen projeler üretmek, sektörde örnek gösterilen bir firma olmak ve faaliyet gösterdiğimiz her alanda çevreye, topluma ve insana duyarlı çözümler geliştirmek.",
      projects: "Tamamlanan Proje",
      ongoing: "Devam Eden",
      cities: "Şehir",
      offices: "Ofis",
      area: "İnşaat Alanı",
    },
    services: {
      overline: "FAALİYET ALANLARI",
      title: "Uçtan Uca İnşaat Çözümleri",
      konut: {
        title: "Konut Projeleri",
        desc: "Apartman, villa ve konut kompleksi inşaatlarında anahtar teslim çözümler.",
      },
      ticari: {
        title: "Ticari Yapılar",
        desc: "Migros, A101, Trendyol gibi markaların ticari yapı inşaatları.",
      },
      fabrika: {
        title: "Fabrika & Sanayi",
        desc: "Tekstil, metal, gıda işleme tesislerinde endüstriyel yapılar.",
      },
      lojistik: {
        title: "Lojistik Depolar",
        desc: "Modern lojistik depo ve dağıtım merkezleri.",
      },
      danismanlik: {
        title: "Proje Danışmanlıkları",
        desc: "Fizibilite, ruhsat ve süreç yönetimi konularında uzman danışmanlık.",
      },
      mimari: {
        title: "Mimari Tasarım & Dekorasyon",
        desc: "Konsept tasarımdan iç mekan dekorasyonuna entegre çözümler.",
      },
    },
    portfolio: {
      overline: "PROJELERİMİZ",
      title: "İmza Attığımız Eserler",
      subtitle: "Tamamlanan, devam eden ve tadilat projelerimiz.",
      all: "Tümü",
      empty: "Henüz proje eklenmedi.",
      viewGallery: "Galeriyi Görüntüle",
      images: "fotoğraf",
      close: "Kapat",
      next: "Sonraki",
      prev: "Önceki",
      swipe: "Kaydır",
    },
    whyus: {
      overline: "DEĞERLERİMİZ",
      title: "Bizi Biz Yapan Değerler",
      guven: {
        title: "Güven",
        desc: "Söz verdiğimiz tarihte, eksiksiz ve taahhüt ettiğimiz kalitede işler teslim ederek müşterilerimizin güvenini kazanıyoruz.",
      },
      memnuniyet: {
        title: "Memnuniyet",
        desc: "Müşteri memnuniyetini her şeyin önünde tutuyoruz. Her projede yüzde yüz memnuniyet hedefliyoruz.",
      },
      kalite: {
        title: "Kalite",
        desc: "Malzemeden işçiliğe her detayda kaliteyi ön planda tutarız. Yıllara meydan okuyan yapılar inşa ederiz.",
      },
      profesyonellik: {
        title: "Profesyonellik",
        desc: "Mühendislik bakış açısı, uzman ekip ve disiplinli yönetim ile kusursuz sonuçlar.",
      },
      seffaflik: {
        title: "Şeffaflık",
        desc: "Tüm süreçlerimizde açık ve net oluruz. Bütçeden malzeme seçimine kadar her aşamada bilgi veririz.",
      },
      surdurulebilir: {
        title: "Sürdürülebilirlik",
        desc: "Çevreye duyarlı, enerji verimliliği yüksek ve uzun ömürlü yapılar. Gelecek nesiller için yaşanabilir dünya.",
      },
    },
    contact: {
      overline: "İLETİŞİM",
      title: "Projenizi Konuşalım",
      subtitle:
        "Kaliteli yapılar, profesyonel çözümler. Deneyimli ekibimizle yanınızdayız. Ücretsiz keşif için bize ulaşın.",
      name: "Ad Soyad",
      phone: "Telefon",
      email: "E-posta (opsiyonel)",
      service: "Hizmet Türü",
      message: "Mesajınız",
      send: "Mesajı Gönder",
      sending: "Gönderiliyor...",
      success: "Mesajınız başarıyla iletildi. En kısa sürede dönüş yapacağız.",
      error: "Bir hata oluştu. Lütfen tekrar deneyin.",
      selectService: "Hizmet seçiniz",
      fillRequired: "Lütfen tüm zorunlu alanları doldurun.",
      offices: "Ofislerimiz",
      headOffice: "Merkez Ofis · İstanbul",
      duzceOffice: "Düzce Ofis",
      archOffice: "Mimari Ofis",
      bukresOffice: "Bükreş Ofis",
      address: "Adres",
      phoneLabel: "Telefon",
      emailLabel: "E-posta",
      headAddress: "Ayvansaray Mah. Sultançeşmesi Sk. Özdemir Apt. No:23 Kapı No:2 Fatih, İstanbul, Türkiye",
    },
    footer: {
      tagline:
        "Kaliteli yapılar, profesyonel çözümler. İnşaat projelerinizde deneyimli ekibimizle yanınızdayız.",
      navigation: "Menü",
      contact: "İletişim",
      follow: "Bizi Takip Edin",
      rights: "Tüm hakları saklıdır.",
    },
    admin: {
      login: "Yönetici Girişi",
      email: "E-posta",
      password: "Şifre",
      signIn: "Giriş Yap",
      dashboard: "Yönetim Paneli",
      projects: "Projeler",
      messages: "Mesajlar",
      logout: "Çıkış",
      add: "Yeni Proje",
      edit: "Düzenle",
      delete: "Sil",
      save: "Kaydet",
      cancel: "İptal",
      title: "Başlık",
      titleEn: "Başlık (EN)",
      category: "Kategori",
      status: "Durum",
      location: "Konum",
      year: "Yıl",
      description: "Açıklama",
      descriptionEn: "Açıklama (EN)",
      imageUrl: "Kapak Görsel URL",
      gallery: "Galeri (her satıra bir URL)",
      featured: "Öne Çıkan",
      noMessages: "Mesaj yok",
      noProjects: "Proje yok",
      markRead: "Okundu",
      unread: "Yeni",
    },
    statuses: {
      "Tamamlanan": "Tamamlanan",
      "Devam Eden": "Devam Eden",
      "Hedef": "Hedef",
      "Tadilat": "Tadilat",
    },
    marketing: {
      overline: "MARKETING",
      title: "Ürün ve Marka Vitrinimiz",
      subtitle: "İnşaat sektörünün ötesinde, yapı malzemesinden endüstriyel tedariğe üç güçlü kategori.",
      hardware: { title: "Hırdavat", desc: "Çelik konstrüksiyon vidaları, yapısal bağlantı elemanları, endüstriyel sabitleme ürünleri ve profesyonel el aletleri. Şantiye ve fabrikalar için uçtan uca tedarik.", tags: ["Çelik bağlantı", "Endüstriyel aletler", "Şantiye sarf"] },
      deco: { title: "Dekorasyon", desc: "Endüstriyel aydınlatma, çelik mobilya, mimari panel sistemleri ve ofis dekorasyonu. Yapıların kabuğunu içerideki estetikle tamamlıyoruz.", tags: ["Çelik mobilya", "Mimari panel", "Ofis tasarım"] },
      market: { title: "Market", desc: "Endüstriyel sarf malzeme, kişisel güvenlik ekipmanı (KKE), iş kıyafeti ve şantiye günlük tüketim ürünleri. Tek tedarikçiden uçtan uca lojistik.", tags: ["KKE & iş güvenliği", "Endüstriyel sarf", "Şantiye tedarik"] },
    },
    consultancy: {
      overline: "PROJE DANIŞMANLIKLARI",
      title: "Yatırımdan Teslime Tam Destek",
      intro: "Yatırımcılar, mimari ofisler ve müteahhitler için fizibiliteden anahtar teslime kadar her aşamada uzman danışmanlık.",
      cards: [
        { title: "Fizibilite Analizi", desc: "Yatırım öncesi teknik ve mali fizibilite, lokasyon analizi ve risk değerlendirmesi." },
        { title: "Ruhsat ve İzin Süreçleri", desc: "İmar, yapı ruhsatı, iskân ve tüm resmi izin süreçlerinin yönetimi." },
        { title: "Şartname ve İhale", desc: "Profesyonel şartname hazırlığı, ihale dosyaları ve yüklenici seçimi danışmanlığı." },
        { title: "Maliyet Yönetimi", desc: "Bütçe planlama, keşif metrajı, hakediş kontrolü ve maliyet optimizasyonu." },
        { title: "Hukuki Danışmanlık", desc: "Sözleşme yönetimi, taraflar arası ihtilaf çözümü ve mevzuat uyumu." },
        { title: "Proje Yönetimi", desc: "Planlama, koordinasyon, denetim ve teslim — uçtan uca proje yönetimi." },
      ],
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "Corporate",
      services: "Services",
      portfolio: "Projects",
      whyus: "Values",
      contact: "Contact",
      adminLogin: "Admin Login",
    },
    hero: {
      overline: "DEMIRAY CONSTRUCTION",
      title: "Projects That Add\nValue to Tomorrow",
      subtitle:
        "In every project, we prioritize quality, aesthetics and functionality. The perfect harmony of robust engineering, refined design and function.",
      cta: "Explore Our Projects",
      ctaSecondary: "Get in Touch",
    },
    about: {
      overline: "CORPORATE",
      title: "Aesthetic Meets Durability",
      body:
        "At Demiray Construction, we build living spaces by combining our sector experience with the principles of trust, quality and sustainability. From day one, we have prioritized customer satisfaction and engineering quality, signing innovative projects.",
      body2:
        "With our strong technical team, solution-oriented approach and ethical principles, we proudly stand as a trusted brand in the construction sector.",
      visionTitle: "Vision",
      vision:
        "To be a leading brand in the construction sector built on quality, trust and sustainability, integrating technology and innovation to deliver livable and aesthetic spaces.",
      missionTitle: "Mission",
      mission:
        "To deliver quality, on-time projects suited to our clients' needs, and to develop solutions that respect the environment, society and people in every area we operate.",
      projects: "Completed Projects",
      ongoing: "Ongoing",
      cities: "Cities",
      offices: "Offices",
      area: "Built Area",
    },
    services: {
      overline: "SERVICES",
      title: "End-to-End Construction Solutions",
      konut: { title: "Residential", desc: "Turnkey solutions for apartments, villas and residential complexes." },
      ticari: { title: "Commercial", desc: "Commercial builds for brands like Migros, A101, Trendyol." },
      fabrika: { title: "Factory & Industrial", desc: "Industrial structures for textile, metal, food processing." },
      lojistik: { title: "Logistics Warehouses", desc: "Modern logistics warehouses and distribution centers." },
      danismanlik: { title: "Project Consultancy", desc: "Expert consulting on feasibility, permits and process management." },
      mimari: { title: "Architectural Design & Decoration", desc: "Integrated solutions from concept design to interior decoration." },
    },
    portfolio: {
      overline: "OUR PROJECTS",
      title: "Works That Bear Our Signature",
      subtitle: "Completed, ongoing and renovation projects.",
      all: "All",
      empty: "No projects yet.",
      viewGallery: "View Gallery",
      images: "photos",
      close: "Close",
      next: "Next",
      prev: "Previous",
      swipe: "Swipe",
    },
    whyus: {
      overline: "OUR VALUES",
      title: "What Defines Us",
      guven: { title: "Trust", desc: "Delivering on the promised date, with full scope and the committed quality." },
      memnuniyet: { title: "Satisfaction", desc: "Customer satisfaction comes first. 100% satisfaction in every project." },
      kalite: { title: "Quality", desc: "From materials to workmanship, every detail. Buildings that defy time." },
      profesyonellik: { title: "Professionalism", desc: "Engineering perspective, expert team, disciplined management." },
      seffaflik: { title: "Transparency", desc: "Open and clear in every process — from budget to material choice." },
      surdurulebilir: { title: "Sustainability", desc: "Eco-friendly, energy-efficient, long-lasting structures." },
    },
    contact: {
      overline: "CONTACT",
      title: "Let's Talk About Your Project",
      subtitle:
        "Quality builds, professional solutions. Reach out for a free site visit.",
      name: "Full Name",
      phone: "Phone",
      email: "Email (optional)",
      service: "Service Type",
      message: "Your Message",
      send: "Send Message",
      sending: "Sending...",
      success: "Your message was sent. We'll be in touch shortly.",
      error: "Something went wrong. Please try again.",
      selectService: "Select a service",
      offices: "Our Offices",
      headOffice: "Head Office · Istanbul",
      officeTitles: { istanbul: "Head Office · Istanbul", duzce: "Düzce Office", celik: "Steel Facility", bosna: "Bosnia & Herzegovina Office", romanya: "Romania Office" },
      fillRequired: "Please fill in all required fields.",
      duzceOffice: "Düzce Office",
      archOffice: "Architecture Office",
      bukresOffice: "Bucharest Office",
      address: "Address",
      phoneLabel: "Phone",
      emailLabel: "Email",
      headAddress: "Ayvansaray Mah. Sultançeşmesi Sk. Özdemir Apt. No:23 Door:2, Fatih, Istanbul, Turkey",
    },
    footer: {
      tagline: "Quality builds, professional solutions. Our experienced team is at your side.",
      navigation: "Navigation",
      contact: "Contact",
      follow: "Follow Us",
      rights: "All rights reserved.",
    },
    admin: {
      login: "Admin Login", email: "Email", password: "Password", signIn: "Sign In",
      dashboard: "Dashboard", projects: "Projects", messages: "Messages", logout: "Logout",
      add: "New Project", edit: "Edit", delete: "Delete", save: "Save", cancel: "Cancel",
      title: "Title", titleEn: "Title (EN)", category: "Category", status: "Status",
      location: "Location", year: "Year", description: "Description", descriptionEn: "Description (EN)",
      imageUrl: "Cover Image URL", gallery: "Gallery (one URL per line)", featured: "Featured",
      noMessages: "No messages", noProjects: "No projects", markRead: "Mark read", unread: "New",
    },
    statuses: {
      "Tamamlanan": "Completed",
      "Devam Eden": "Ongoing",
      "Hedef": "Target",
      "Tadilat": "Renovation",
    },
    marketing: {
      overline: "MARKETING",
      title: "Our Product & Brand Showcase",
      subtitle: "Beyond construction — three strong categories from building materials to industrial supply.",
      hardware: { title: "Hardware", desc: "Steel construction screws, structural fasteners, industrial fixing products and professional hand tools. End-to-end supply for sites and factories.", tags: ["Steel fasteners", "Industrial tools", "Site consumables"] },
      deco: { title: "Decoration", desc: "Industrial lighting, steel furniture, architectural panel systems and office decoration.", tags: ["Steel furniture", "Architectural panels", "Office design"] },
      market: { title: "Market", desc: "Industrial consumables, personal protective equipment (PPE), workwear and daily consumption products. Single-vendor logistics.", tags: ["PPE & safety", "Industrial supplies", "Site supply"] },
    },
    consultancy: {
      overline: "PROJECT CONSULTANCY",
      title: "Full Support from Investment to Handover",
      intro: "For investors, architectural offices and contractors — expert consultancy at every stage from feasibility to turnkey delivery.",
      cards: [
        { title: "Feasibility Analysis", desc: "Technical & financial feasibility, location analysis and risk assessment before investment." },
        { title: "Permits & Approvals", desc: "Management of zoning, building permits, occupancy and all official approval processes." },
        { title: "Specifications & Tenders", desc: "Professional spec preparation, tender packages and contractor selection consultancy." },
        { title: "Cost Management", desc: "Budget planning, BoQ, progress-payment control and cost optimization." },
        { title: "Legal Advisory", desc: "Contract management, dispute resolution and regulatory compliance." },
        { title: "Project Management", desc: "Planning, coordination, supervision and handover — end-to-end PM." },
      ],
    },
  },
};

const I18nContext = createContext({ lang: "tr", t: translations.tr, setLang: () => {} });

// Partial translations: missing keys fall back to English
const partial = {
  ar: {
    nav: { home: "الرئيسية", about: "الشركة", services: "خدماتنا", portfolio: "المشاريع", whyus: "قيمنا", contact: "اتصل بنا", adminLogin: "تسجيل الدخول" },
    hero: {
      overline: "ديميراي للإنشاءات",
      title: "مشاريع تضيف\nقيمة للمستقبل",
      subtitle: "نضع الجودة والجمال والوظيفية في صميم كل مشروع.",
      cta: "استكشف مشاريعنا",
      ctaSecondary: "تواصل معنا",
    },
    about: {
      overline: "الشركة",
      title: "الجمال يلتقي بالمتانة",
      body: "نبني فضاءات حياة بدمج خبرتنا مع مبادئ الثقة والجودة والاستدامة. منذ تأسيسنا نولي الأولوية لرضا العملاء وجودة الهندسة.",
      body2: "بفضل فريقنا التقني القوي ونهجنا القائم على الحلول، نقف بفخر كعلامة موثوقة في قطاع البناء.",
      visionTitle: "الرؤية", vision: "أن نكون علامة رائدة في قطاع البناء على أساس الجودة والثقة والاستدامة.",
      missionTitle: "المهمة", mission: "تقديم مشاريع جودة عالية في الوقت المحدد، وتطوير حلول صديقة للبيئة والمجتمع.",
      projects: "مشاريع منجزة", ongoing: "قيد التنفيذ", cities: "مدن", offices: "مكاتب",
    },
    services: {
      overline: "خدماتنا", title: "حلول إنشائية شاملة",
      konut: { title: "مشاريع سكنية", desc: "حلول تسليم المفتاح للشقق والفلل والمجمعات السكنية." },
      ticari: { title: "إنشاءات تجارية", desc: "إنشاءات تجارية لعلامات مثل ميجروس وأ101 وترنديول." },
      fabrika: { title: "مصانع وصناعات", desc: "هياكل صناعية للنسيج والمعادن ومعالجة الأغذية." },
      lojistik: { title: "مستودعات لوجستية", desc: "مستودعات لوجستية ومراكز توزيع حديثة." },
      danismanlik: { title: "استشارات المشاريع", desc: "استشارات خبراء في دراسات الجدوى والتصاريح وإدارة العمليات." },
      mimari: { title: "تصميم معماري وديكور", desc: "حلول متكاملة من التصميم المفاهيمي إلى الديكور الداخلي." },
    },
    portfolio: { overline: "مشاريعنا", title: "أعمال تحمل توقيعنا", subtitle: "مشاريع منجزة وجارية.", all: "الكل", empty: "لا توجد مشاريع.", viewGallery: "عرض المعرض", images: "صور", close: "إغلاق", next: "التالي", prev: "السابق" },
    whyus: {
      overline: "قيمنا", title: "ما يحددنا",
      guven: { title: "الثقة", desc: "نسلم في الموعد المتفق عليه بالنطاق الكامل والجودة الملتزم بها." },
      memnuniyet: { title: "الرضا", desc: "رضا العميل أولاً. رضا 100٪ في كل مشروع." },
      kalite: { title: "الجودة", desc: "من المواد إلى الصنعة، كل التفاصيل. مبانٍ تتحدى الزمن." },
      profesyonellik: { title: "الاحترافية", desc: "منظور هندسي، فريق خبير، إدارة منضبطة." },
      seffaflik: { title: "الشفافية", desc: "وضوح في كل عملية — من الميزانية إلى اختيار المواد." },
      surdurulebilir: { title: "الاستدامة", desc: "هياكل صديقة للبيئة وموفرة للطاقة وطويلة الأمد." },
    },
    contact: {
      overline: "اتصل بنا", title: "لنتحدث عن مشروعك", subtitle: "حلول مهنية وبناء عالي الجودة. تواصل معنا لزيارة موقعية مجانية.",
      name: "الاسم الكامل", phone: "الهاتف", email: "البريد الإلكتروني (اختياري)", service: "نوع الخدمة", message: "رسالتك",
      send: "إرسال", sending: "جارٍ الإرسال...", success: "تم إرسال رسالتك. سنتواصل قريباً.", error: "حدث خطأ. حاول مرة أخرى.",
      selectService: "اختر خدمة", offices: "مكاتبنا",
    },
    footer: { tagline: "حلول مهنية وبناء عالي الجودة.", navigation: "التنقل", contact: "اتصل بنا", follow: "تابعنا", rights: "جميع الحقوق محفوظة." },
    statuses: { "Tamamlanan": "منجز", "Devam Eden": "قيد التنفيذ", "Hedef": "هدف", "Tadilat": "تجديد" },
    marketing: {
      overline: "تسويق", title: "واجهة منتجاتنا وعلاماتنا", subtitle: "ثلاث فئات قوية من مواد البناء إلى التوريد الصناعي.",
      hardware: { title: "أدوات", desc: "براغي الهياكل الفولاذية وعناصر التثبيت ومنتجات التثبيت الصناعية والأدوات اليدوية المهنية.", tags: ["وصلات فولاذية", "أدوات صناعية", "مستهلكات الموقع"] },
      deco: { title: "ديكور", desc: "إضاءة صناعية، أثاث فولاذي، أنظمة ألواح معمارية وديكور مكاتب.", tags: ["أثاث فولاذي", "ألواح معمارية", "تصميم مكاتب"] },
      market: { title: "متجر", desc: "مستهلكات صناعية ومعدات سلامة شخصية وملابس عمل ومنتجات استهلاك يومية.", tags: ["سلامة وحماية", "مستهلكات", "توريد المواقع"] },
    },
    consultancy: {
      overline: "استشارات المشاريع", title: "دعم كامل من الاستثمار حتى التسليم",
      intro: "للمستثمرين والمكاتب المعمارية والمقاولين، استشارات خبراء في كل مرحلة من دراسة الجدوى إلى التسليم بالمفتاح.",
      cards: [
        { title: "تحليل الجدوى", desc: "الجدوى التقنية والمالية، تحليل الموقع، وتقييم المخاطر قبل الاستثمار." },
        { title: "التصاريح والإجازات", desc: "إدارة عمليات تخطيط البناء والإجازات والتراخيص الرسمية." },
        { title: "المواصفات والعطاءات", desc: "إعداد المواصفات الفنية، ملفات العطاءات، واستشارة اختيار المقاول." },
        { title: "إدارة التكاليف", desc: "تخطيط الميزانية، حساب الكميات، مراقبة الفواتير وتحسين التكلفة." },
        { title: "الاستشارات القانونية", desc: "إدارة العقود، حل النزاعات والامتثال للوائح." },
        { title: "إدارة المشاريع", desc: "التخطيط والتنسيق والإشراف والتسليم — إدارة شاملة." },
      ],
    },
  },
  bs: {
    nav: { home: "Početna", about: "O nama", services: "Usluge", portfolio: "Projekti", whyus: "Vrijednosti", contact: "Kontakt", adminLogin: "Prijava" },
    hero: { overline: "DEMIRAY GRADNJA", title: "Projekti koji dodaju\nvrijednost sutrašnjici", subtitle: "U svakom projektu prioritet su kvalitet, estetika i funkcionalnost.", cta: "Istražite projekte", ctaSecondary: "Kontaktirajte nas" },
    about: { overline: "O NAMA", title: "Estetika susreće trajnost",
      body: "Gradimo prostore za život kombinujući naše iskustvo sa principima povjerenja, kvaliteta i održivosti.",
      body2: "S jakim tehničkim timom i etičkim principima, sa ponosom stojimo kao pouzdan brend u građevinskom sektoru.",
      visionTitle: "Vizija", vision: "Biti vodeći brend u građevinskom sektoru, zasnovan na kvalitetu i održivosti.",
      missionTitle: "Misija", mission: "Isporučiti kvalitetne projekte na vrijeme uz rješenja prijateljska okolišu i društvu.",
      projects: "Završeni projekti", ongoing: "U toku", cities: "Gradovi", offices: "Uredi" },
    services: { overline: "USLUGE", title: "Sveobuhvatna građevinska rješenja",
      konut: { title: "Stambeni projekti", desc: "Ključ-u-ruke rješenja za stanove, vile i stambene komplekse." },
      ticari: { title: "Komercijalna gradnja", desc: "Komercijalna gradnja za brendove kao Migros, A101, Trendyol." },
      fabrika: { title: "Fabrika i industrija", desc: "Industrijske strukture za tekstil, metal i preradu hrane." },
      lojistik: { title: "Logistička skladišta", desc: "Moderna logistička skladišta i distributivni centri." },
      danismanlik: { title: "Konsalting projekata", desc: "Stručno savjetovanje o studijama izvodljivosti i upravljanju procesima." },
      mimari: { title: "Arhitektonski dizajn i dekoracija", desc: "Integrirana rješenja od konceptualnog dizajna do enterijera." } },
    portfolio: { overline: "NAŠI PROJEKTI", title: "Djela s našim potpisom", subtitle: "Završeni i tekući projekti.", all: "Sve", empty: "Još nema projekata.", viewGallery: "Pogledaj galeriju", close: "Zatvori", next: "Sljedeće", prev: "Prethodno" },
    whyus: { overline: "NAŠE VRIJEDNOSTI", title: "Šta nas definiše",
      guven: { title: "Povjerenje", desc: "Isporuka u dogovorenom roku, u punom obimu i s ugovorenim kvalitetom." },
      memnuniyet: { title: "Zadovoljstvo", desc: "Zadovoljstvo klijenta na prvom mjestu. 100% zadovoljstvo u svakom projektu." },
      kalite: { title: "Kvalitet", desc: "Od materijala do izvedbe, svaki detalj. Objekti koji prkose vremenu." },
      profesyonellik: { title: "Profesionalizam", desc: "Inženjerska perspektiva, stručan tim, disciplinovano upravljanje." },
      seffaflik: { title: "Transparentnost", desc: "Otvoreni i jasni u svakom procesu — od budžeta do izbora materijala." },
      surdurulebilir: { title: "Održivost", desc: "Ekološke, energetski efikasne i dugotrajne strukture." } },
    contact: { overline: "KONTAKT", title: "Razgovarajmo o vašem projektu", subtitle: "Kvalitetna gradnja, profesionalna rješenja. Javite se za besplatan obilazak.",
      name: "Ime i prezime", phone: "Telefon", email: "Email (opcionalno)", service: "Vrsta usluge", message: "Vaša poruka",
      send: "Pošalji", sending: "Slanje...", success: "Vaša poruka je poslana. Javit ćemo vam se uskoro.", error: "Došlo je do greške.", selectService: "Odaberite uslugu", offices: "Naši uredi" },
    footer: { tagline: "Kvalitetna gradnja, profesionalna rješenja.", navigation: "Navigacija", contact: "Kontakt", follow: "Pratite nas", rights: "Sva prava pridržana." },
    statuses: { "Tamamlanan": "Završeno", "Devam Eden": "U toku", "Hedef": "Cilj", "Tadilat": "Renovacija" },
    marketing: { overline: "MARKETING", title: "Naš izlog proizvoda i brendova", subtitle: "Tri snažne kategorije od građevinskog materijala do industrijske nabavke.",
      hardware: { title: "Alati", desc: "Vijci za čelične konstrukcije, elementi spajanja, industrijski pričvrsni proizvodi i profesionalni alati.", tags: ["Čelični spojevi", "Industrijski alati", "Potrošni materijal"] },
      deco: { title: "Dekoracija", desc: "Industrijsko osvjetljenje, čelični namještaj, arhitektonski paneli i kancelarijska dekoracija.", tags: ["Čelični namještaj", "Arhitektonski paneli", "Dizajn ureda"] },
      market: { title: "Market", desc: "Industrijski potrošni materijal, zaštitna oprema, radna odjeća i svakodnevni potrošni proizvodi.", tags: ["Zaštitna oprema", "Potrošno", "Snabdijevanje gradilišta"] } },
    consultancy: { overline: "KONSALTING PROJEKATA", title: "Potpuna podrška od investicije do isporuke",
      intro: "Za investitore, arhitektonske urede i izvođače — stručno savjetovanje u svakoj fazi.",
      cards: [
        { title: "Analiza izvodljivosti", desc: "Tehnička i finansijska izvodljivost, analiza lokacije, procjena rizika prije ulaganja." },
        { title: "Dozvole i odobrenja", desc: "Upravljanje procesima zoniranja, građevinskih dozvola i službenih odobrenja." },
        { title: "Specifikacije i tenderi", desc: "Priprema specifikacija, tenderskih dokumenata i savjetovanje o odabiru izvođača." },
        { title: "Upravljanje troškovima", desc: "Planiranje budžeta, predmjer, kontrola situacija i optimizacija troškova." },
        { title: "Pravno savjetovanje", desc: "Upravljanje ugovorima, rješavanje sporova i usklađenost s propisima." },
        { title: "Upravljanje projektom", desc: "Planiranje, koordinacija, nadzor i predaja — od-kraja-do-kraja." },
      ] },
  },
  hr: {
    nav: { home: "Naslovna", about: "O nama", services: "Usluge", portfolio: "Projekti", whyus: "Vrijednosti", contact: "Kontakt", adminLogin: "Prijava" },
    hero: { overline: "DEMIRAY GRADNJA", title: "Projekti koji dodaju\nvrijednost sutrašnjici", subtitle: "U svakom projektu prioritet su kvaliteta, estetika i funkcionalnost.", cta: "Istražite projekte", ctaSecondary: "Kontaktirajte nas" },
    about: { overline: "O NAMA", title: "Estetika susreće trajnost",
      body: "Gradimo prostore za život kombinirajući naše iskustvo s načelima povjerenja, kvalitete i održivosti.",
      body2: "S jakim tehničkim timom i etičkim načelima, ponosno stojimo kao pouzdan brend u građevinskom sektoru.",
      visionTitle: "Vizija", vision: "Biti vodeći brend u građevinskom sektoru zasnovan na kvaliteti i održivosti.",
      missionTitle: "Misija", mission: "Isporučiti kvalitetne projekte na vrijeme uz ekološki prihvatljiva rješenja.",
      projects: "Završeni projekti", ongoing: "U tijeku", cities: "Gradovi", offices: "Uredi" },
    services: { overline: "USLUGE", title: "Sveobuhvatna građevinska rješenja",
      konut: { title: "Stambeni projekti", desc: "Ključ-u-ruke rješenja za stanove, vile i stambene komplekse." },
      ticari: { title: "Komercijalna gradnja", desc: "Komercijalna gradnja za brendove poput Migrosa, A101, Trendyol." },
      fabrika: { title: "Tvornica i industrija", desc: "Industrijske strukture za tekstil, metal i prehrambenu industriju." },
      lojistik: { title: "Logistička skladišta", desc: "Moderna logistička skladišta i distribucijski centri." },
      danismanlik: { title: "Konzalting projekata", desc: "Stručno savjetovanje o izvodljivosti, dozvolama i upravljanju procesima." },
      mimari: { title: "Arhitektonski dizajn i dekoracija", desc: "Integrirana rješenja od konceptualnog dizajna do interijera." } },
    portfolio: { overline: "NAŠI PROJEKTI", title: "Djela s našim potpisom", subtitle: "Završeni i tekući projekti.", all: "Sve", empty: "Još nema projekata.", viewGallery: "Pogledaj galeriju", close: "Zatvori", next: "Sljedeće", prev: "Prethodno" },
    whyus: { overline: "NAŠE VRIJEDNOSTI", title: "Što nas definira",
      guven: { title: "Povjerenje", desc: "Isporuka u dogovorenom roku, u punom opsegu i s ugovorenom kvalitetom." },
      memnuniyet: { title: "Zadovoljstvo", desc: "Zadovoljstvo klijenta na prvom mjestu. 100% zadovoljstvo u svakom projektu." },
      kalite: { title: "Kvaliteta", desc: "Od materijala do izvedbe — građevine koje prkose vremenu." },
      profesyonellik: { title: "Profesionalnost", desc: "Inženjerska perspektiva, stručan tim, disciplinirano upravljanje." },
      seffaflik: { title: "Transparentnost", desc: "Otvoreni i jasni u svakom procesu — od proračuna do izbora materijala." },
      surdurulebilir: { title: "Održivost", desc: "Ekološke, energetski učinkovite i dugotrajne strukture." } },
    contact: { overline: "KONTAKT", title: "Razgovarajmo o vašem projektu", subtitle: "Kvalitetna gradnja, profesionalna rješenja. Javite se za besplatan obilazak.",
      name: "Ime i prezime", phone: "Telefon", email: "Email (neobavezno)", service: "Vrsta usluge", message: "Vaša poruka",
      send: "Pošalji", sending: "Slanje...", success: "Vaša poruka je poslana.", error: "Došlo je do pogreške.", selectService: "Odaberite uslugu", offices: "Naši uredi" },
    footer: { tagline: "Kvalitetna gradnja, profesionalna rješenja.", navigation: "Navigacija", contact: "Kontakt", follow: "Pratite nas", rights: "Sva prava pridržana." },
    statuses: { "Tamamlanan": "Završeno", "Devam Eden": "U tijeku", "Hedef": "Cilj", "Tadilat": "Renovacija" },
    marketing: { overline: "MARKETING", title: "Naš izlog proizvoda i brendova", subtitle: "Tri snažne kategorije od građevinskog materijala do industrijske nabave.",
      hardware: { title: "Alati", desc: "Vijci za čelične konstrukcije, elementi spajanja, industrijski pričvrsni proizvodi i profesionalni alati.", tags: ["Čelični spojevi", "Industrijski alati", "Potrošno"] },
      deco: { title: "Dekoracija", desc: "Industrijska rasvjeta, čelični namještaj, arhitektonski paneli i uredska dekoracija.", tags: ["Čelični namještaj", "Arhitektonski paneli", "Uredski dizajn"] },
      market: { title: "Trgovina", desc: "Industrijski potrošni materijal, zaštitna oprema, radna odjeća i svakodnevni potrošni proizvodi.", tags: ["Zaštitna oprema", "Potrošno", "Opskrba gradilišta"] } },
    consultancy: { overline: "KONZALTING PROJEKATA", title: "Potpuna podrška od ulaganja do isporuke",
      intro: "Za investitore, arhitektonske urede i izvođače — stručno savjetovanje u svakoj fazi.",
      cards: [
        { title: "Analiza izvodljivosti", desc: "Tehnička i financijska izvodljivost prije ulaganja." },
        { title: "Dozvole i odobrenja", desc: "Upravljanje procesima građevinskih dozvola i službenih odobrenja." },
        { title: "Specifikacije i natječaji", desc: "Priprema specifikacija, dokumentacije i savjetovanje o odabiru izvođača." },
        { title: "Upravljanje troškovima", desc: "Planiranje proračuna, predmjer, kontrola situacija i optimizacija." },
        { title: "Pravno savjetovanje", desc: "Upravljanje ugovorima, rješavanje sporova i usklađenost s propisima." },
        { title: "Upravljanje projektom", desc: "Planiranje, koordinacija, nadzor i isporuka — kraj-do-kraja." },
      ] },
  },
  sr: {
    nav: { home: "Почетна", about: "О нама", services: "Услуге", portfolio: "Пројекти", whyus: "Вредности", contact: "Контакт", adminLogin: "Пријава" },
    hero: { overline: "ДЕМИРАЈ ГРАДЊА", title: "Пројекти који додају\nвредност сутрашњици", subtitle: "У сваком пројекту приоритет су квалитет, естетика и функционалност.", cta: "Истражите пројекте", ctaSecondary: "Контактирајте нас" },
    about: { overline: "О НАМА", title: "Естетика среће трајност",
      body: "Градимо просторе за живот спајајући искуство са принципима поверења, квалитета и одрживости.",
      body2: "Са јаким техничким тимом и етичким принципима, поносно стојимо као поуздан бренд у грађевинском сектору.",
      visionTitle: "Визија", vision: "Бити водећи бренд у грађевинском сектору заснован на квалитету и одрживости.",
      missionTitle: "Мисија", mission: "Испоручити квалитетне пројекте на време уз решења пријатељска окружењу.",
      projects: "Завршени пројекти", ongoing: "У току", cities: "Градови", offices: "Канцеларије" },
    services: { overline: "УСЛУГЕ", title: "Свеобухватна грађевинска решења",
      konut: { title: "Стамбени пројекти", desc: "Кључ-у-руке решења за станове, виле и стамбене комплексе." },
      ticari: { title: "Комерцијална градња", desc: "Комерцијална градња за брендове попут Мигроса, А101, Трендјол." },
      fabrika: { title: "Фабрика и индустрија", desc: "Индустријске структуре за текстил, метал и прераду хране." },
      lojistik: { title: "Логистичка складишта", desc: "Модерна логистичка складишта и дистрибутивни центри." },
      danismanlik: { title: "Консалтинг пројеката", desc: "Стручно саветовање о изводљивости, дозволама и управљању процесима." },
      mimari: { title: "Архитектонски дизајн и декорација", desc: "Интегрисана решења од концептуалног дизајна до ентеријера." } },
    portfolio: { overline: "НАШИ ПРОЈЕКТИ", title: "Дела с нашим потписом", subtitle: "Завршени и текући пројекти.", all: "Све", empty: "Још нема пројеката.", viewGallery: "Погледај галерију", close: "Затвори", next: "Следеће", prev: "Претходно" },
    whyus: { overline: "НАШЕ ВРЕДНОСТИ", title: "Шта нас одређује",
      guven: { title: "Поверење", desc: "Испорука у уговореном року, у пуном обиму и са уговореним квалитетом." },
      memnuniyet: { title: "Задовољство", desc: "Задовољство клијента на првом месту. 100% задовољство у сваком пројекту." },
      kalite: { title: "Квалитет", desc: "Од материјала до израде — грађевине које пркосе времену." },
      profesyonellik: { title: "Професионалност", desc: "Инжењерска перспектива, стручан тим, дисциплиновано управљање." },
      seffaflik: { title: "Транспарентност", desc: "Отворени и јасни у сваком процесу — од буџета до избора материјала." },
      surdurulebilir: { title: "Одрживост", desc: "Еколошке, енергетски ефикасне и дуготрајне структуре." } },
    contact: { overline: "КОНТАКТ", title: "Хајде да разговарамо о вашем пројекту", subtitle: "Квалитетна градња, професионална решења.",
      name: "Име и презиме", phone: "Телефон", email: "Имејл (необавезно)", service: "Врста услуге", message: "Ваша порука",
      send: "Пошаљи", sending: "Слање...", success: "Ваша порука је послата.", error: "Дошло је до грешке.", selectService: "Изаберите услугу", offices: "Наше канцеларије" },
    footer: { tagline: "Квалитетна градња, професионална решења.", navigation: "Навигација", contact: "Контакт", follow: "Пратите нас", rights: "Сва права задржана." },
    statuses: { "Tamamlanan": "Завршено", "Devam Eden": "У току", "Hedef": "Циљ", "Tadilat": "Реновирање" },
    marketing: { overline: "МАРКЕТИНГ", title: "Наш излог производа и брендова", subtitle: "Три снажне категорије од грађевинског материјала до индустријске набавке.",
      hardware: { title: "Алати", desc: "Завртњи за челичне конструкције, елементи спајања, индустријски причврсни производи и професионални алати.", tags: ["Челични спојеви", "Индустријски алати", "Потрошно"] },
      deco: { title: "Декорација", desc: "Индустријско осветљење, челични намештај, архитектонски панели и канцеларијска декорација.", tags: ["Челични намештај", "Архитектонски панели", "Дизајн канцеларија"] },
      market: { title: "Маркет", desc: "Индустријски потрошни материјал, опрема за личну заштиту, радна одећа и свакодневни производи.", tags: ["Заштита и сигурност", "Потрошно", "Снабдевање градилишта"] } },
    consultancy: { overline: "КОНСАЛТИНГ ПРОЈЕКАТА", title: "Потпуна подршка од улагања до испоруке",
      intro: "За инвеститоре, архитектонске канцеларије и извођаче — стручно саветовање у свакој фази.",
      cards: [
        { title: "Анализа изводљивости", desc: "Техничка и финансијска изводљивост пре улагања." },
        { title: "Дозволе и одобрења", desc: "Управљање процесима грађевинских дозвола." },
        { title: "Спецификације и тендери", desc: "Припрема спецификација, тендерске документације и одабир извођача." },
        { title: "Управљање трошковима", desc: "Планирање буџета, предмер, контрола ситуација и оптимизација." },
        { title: "Правно саветовање", desc: "Управљање уговорима, решавање спорова и усклађеност." },
        { title: "Управљање пројектом", desc: "Планирање, координација, надзор и испорука." },
      ] },
  },
  ro: {
    nav: { home: "Acasă", about: "Despre", services: "Servicii", portfolio: "Proiecte", whyus: "Valori", contact: "Contact", adminLogin: "Autentificare" },
    hero: { overline: "DEMIRAY CONSTRUCȚII", title: "Proiecte care adaugă\nvaloare viitorului", subtitle: "În fiecare proiect prioritizăm calitatea, estetica și funcționalitatea.", cta: "Descoperă proiectele", ctaSecondary: "Contactează-ne" },
    about: { overline: "DESPRE", title: "Estetica întâlnește durabilitatea",
      body: "Construim spații de viață combinând experiența noastră cu principiile de încredere, calitate și sustenabilitate.",
      body2: "Cu o echipă tehnică puternică și principii etice, ne mândrim ca un brand de încredere în sectorul construcțiilor.",
      visionTitle: "Viziune", vision: "Să fim un brand lider în construcții, bazat pe calitate, încredere și sustenabilitate.",
      missionTitle: "Misiune", mission: "Să livrăm proiecte de calitate la timp, cu soluții prietenoase cu mediul.",
      projects: "Proiecte finalizate", ongoing: "În curs", cities: "Orașe", offices: "Birouri", area: "Suprafață Construită" },
    services: { overline: "SERVICII", title: "Soluții complete de construcții",
      konut: { title: "Rezidențial", desc: "Soluții la cheie pentru apartamente, vile și complexe rezidențiale." },
      ticari: { title: "Comercial", desc: "Construcții comerciale pentru branduri ca Migros, A101, Trendyol." },
      fabrika: { title: "Fabrici și industrie", desc: "Structuri industriale pentru textile, metal și procesare alimentară." },
      lojistik: { title: "Depozite logistice", desc: "Depozite logistice moderne și centre de distribuție." },
      danismanlik: { title: "Consultanță proiecte", desc: "Consultanță expertă în studii de fezabilitate, permise și management." },
      mimari: { title: "Design arhitectural & decor", desc: "Soluții integrate de la concept la decorare interioară." } },
    portfolio: { overline: "PROIECTELE NOASTRE", title: "Lucrări cu semnătura noastră", subtitle: "Proiecte finalizate și în curs.", all: "Toate", empty: "Niciun proiect.", viewGallery: "Vezi galeria", images: "fotografii", close: "Închide", next: "Următor", prev: "Anterior", swipe: "Glisează" },
    whyus: { overline: "VALORILE NOASTRE", title: "Ce ne definește",
      guven: { title: "Încredere", desc: "Livrare la termenul promis, la scopul complet și calitatea convenită." },
      memnuniyet: { title: "Satisfacție", desc: "Satisfacția clientului pe primul loc. 100% satisfacție în fiecare proiect." },
      kalite: { title: "Calitate", desc: "De la materiale la manoperă, fiecare detaliu. Clădiri care sfidează timpul." },
      profesyonellik: { title: "Profesionalism", desc: "Perspectivă inginerească, echipă expertă, management disciplinat." },
      seffaflik: { title: "Transparență", desc: "Deschiși și clari în fiecare proces — de la buget la alegerea materialelor." },
      surdurulebilir: { title: "Sustenabilitate", desc: "Structuri ecologice, eficiente energetic și durabile." } },
    contact: { overline: "CONTACT", title: "Să discutăm despre proiectul tău", subtitle: "Construcții de calitate, soluții profesionale.",
      name: "Nume complet", phone: "Telefon", email: "Email (opțional)", service: "Tip de serviciu", message: "Mesajul tău",
      send: "Trimite", sending: "Se trimite...", success: "Mesajul tău a fost trimis.", error: "Ceva nu a funcționat.", selectService: "Selectează serviciul", offices: "Birourile noastre",
      fillRequired: "Te rugăm să completezi toate câmpurile obligatorii.",
      officeTitles: { istanbul: "Birou Central · Istanbul", duzce: "Biroul Düzce", celik: "Fabrica de Oțel", bosna: "Biroul Bosnia și Herțegovina", romanya: "Biroul România" } },
    footer: { tagline: "Construcții de calitate, soluții profesionale.", navigation: "Navigație", contact: "Contact", follow: "Urmărește-ne", rights: "Toate drepturile rezervate." },
    statuses: { "Tamamlanan": "Finalizat", "Devam Eden": "În curs", "Hedef": "Țintă", "Tadilat": "Renovare" },
    marketing: { overline: "MARKETING", title: "Vitrina noastră de produse și branduri", subtitle: "Trei categorii puternice de la materiale de construcții la aprovizionare industrială.",
      hardware: { title: "Feronerie", desc: "Șuruburi pentru structuri metalice, elemente de fixare, produse de fixare industriale și unelte profesionale.", tags: ["Îmbinări metalice", "Unelte industriale", "Consumabile șantier"] },
      deco: { title: "Decor", desc: "Iluminat industrial, mobilier din oțel, panouri arhitecturale și decor de birou.", tags: ["Mobilier metalic", "Panouri", "Design birou"] },
      market: { title: "Market", desc: "Consumabile industriale, echipament de protecție, îmbrăcăminte de lucru și produse de consum zilnic.", tags: ["EPP & siguranță", "Consumabile", "Aprovizionare șantier"] } },
    consultancy: { overline: "CONSULTANȚĂ PROIECTE", title: "Suport complet de la investiție la livrare",
      intro: "Pentru investitori, birouri de arhitectură și antreprenori — consultanță expertă în fiecare etapă.",
      cards: [
        { title: "Analiză de fezabilitate", desc: "Fezabilitate tehnică și financiară, analiză de locație și evaluarea riscurilor." },
        { title: "Permise și avize", desc: "Managementul proceselor de zonare, autorizații de construcție și aprobări oficiale." },
        { title: "Specificații și licitații", desc: "Pregătire specificații tehnice, dosare de licitație și consultanță selecție antreprenor." },
        { title: "Management de costuri", desc: "Planificare buget, antemăsurători, control situații și optimizare." },
        { title: "Consultanță juridică", desc: "Management contracte, rezolvare dispute și conformitate cu reglementările." },
        { title: "Management de proiect", desc: "Planificare, coordonare, supervizare și predare — end-to-end." },
      ] },
  },
  de: {
    nav: { home: "Start", about: "Über uns", services: "Leistungen", portfolio: "Projekte", whyus: "Werte", contact: "Kontakt", adminLogin: "Anmelden" },
    hero: { overline: "DEMIRAY BAU", title: "Projekte mit Mehrwert\nfür morgen", subtitle: "In jedem Projekt stehen Qualität, Ästhetik und Funktion an erster Stelle.", cta: "Projekte ansehen", ctaSecondary: "Kontakt aufnehmen" },
    about: { overline: "ÜBER UNS", title: "Ästhetik trifft Beständigkeit",
      body: "Wir schaffen Lebensräume, indem wir unsere Erfahrung mit den Prinzipien Vertrauen, Qualität und Nachhaltigkeit verbinden.",
      body2: "Mit unserem starken technischen Team und ethischen Grundsätzen stehen wir stolz als vertrauenswürdige Marke im Bausektor.",
      visionTitle: "Vision", vision: "Eine führende Marke im Bausektor zu sein, basierend auf Qualität, Vertrauen und Nachhaltigkeit.",
      missionTitle: "Mission", mission: "Qualitative Projekte pünktlich liefern und umweltfreundliche Lösungen entwickeln.",
      projects: "Abgeschlossene Projekte", ongoing: "Laufend", cities: "Städte", offices: "Büros" },
    services: { overline: "LEISTUNGEN", title: "Ganzheitliche Baulösungen",
      konut: { title: "Wohnprojekte", desc: "Schlüsselfertige Lösungen für Wohnungen, Villen und Wohnkomplexe." },
      ticari: { title: "Gewerbebau", desc: "Gewerbebau für Marken wie Migros, A101, Trendyol." },
      fabrika: { title: "Fabrik & Industrie", desc: "Industrielle Strukturen für Textil, Metall und Lebensmittelverarbeitung." },
      lojistik: { title: "Logistiklager", desc: "Moderne Logistiklager und Verteilzentren." },
      danismanlik: { title: "Projektberatung", desc: "Expertenberatung zu Machbarkeit, Genehmigungen und Prozessmanagement." },
      mimari: { title: "Architekturdesign & Dekoration", desc: "Integrierte Lösungen vom Konzept bis zur Innendekoration." } },
    portfolio: { overline: "UNSERE PROJEKTE", title: "Werke mit unserer Handschrift", subtitle: "Abgeschlossene und laufende Projekte.", all: "Alle", empty: "Noch keine Projekte.", viewGallery: "Galerie ansehen", close: "Schließen", next: "Weiter", prev: "Zurück" },
    whyus: { overline: "UNSERE WERTE", title: "Was uns ausmacht",
      guven: { title: "Vertrauen", desc: "Lieferung zum vereinbarten Termin, im vollen Umfang und mit zugesagter Qualität." },
      memnuniyet: { title: "Zufriedenheit", desc: "Kundenzufriedenheit steht an erster Stelle. 100% in jedem Projekt." },
      kalite: { title: "Qualität", desc: "Vom Material bis zur Ausführung — Bauten, die der Zeit trotzen." },
      profesyonellik: { title: "Professionalität", desc: "Ingenieurperspektive, Expertenteam, disziplinierte Führung." },
      seffaflik: { title: "Transparenz", desc: "Offen und klar in jedem Prozess — vom Budget bis zur Materialauswahl." },
      surdurulebilir: { title: "Nachhaltigkeit", desc: "Umweltfreundliche, energieeffiziente und langlebige Strukturen." } },
    contact: { overline: "KONTAKT", title: "Sprechen wir über Ihr Projekt", subtitle: "Qualitätsbau, professionelle Lösungen.",
      name: "Vollständiger Name", phone: "Telefon", email: "E-Mail (optional)", service: "Leistungsart", message: "Ihre Nachricht",
      send: "Senden", sending: "Wird gesendet...", success: "Ihre Nachricht wurde gesendet.", error: "Ein Fehler ist aufgetreten.", selectService: "Leistung wählen", offices: "Unsere Büros" },
    footer: { tagline: "Qualitätsbau, professionelle Lösungen.", navigation: "Navigation", contact: "Kontakt", follow: "Folgen Sie uns", rights: "Alle Rechte vorbehalten." },
    statuses: { "Tamamlanan": "Abgeschlossen", "Devam Eden": "Laufend", "Hedef": "Ziel", "Tadilat": "Renovierung" },
    marketing: { overline: "MARKETING", title: "Unser Produkt- und Markenschaufenster", subtitle: "Drei starke Kategorien — von Baumaterial bis zur Industrieversorgung.",
      hardware: { title: "Werkzeuge", desc: "Stahlbau-Schrauben, Verbindungselemente, industrielle Befestigungsprodukte und professionelle Handwerkzeuge.", tags: ["Stahlverbindungen", "Industriewerkzeug", "Baustellenbedarf"] },
      deco: { title: "Dekoration", desc: "Industrielle Beleuchtung, Stahlmöbel, architektonische Paneelsysteme und Bürodekoration.", tags: ["Stahlmöbel", "Paneele", "Bürodesign"] },
      market: { title: "Markt", desc: "Industrielle Verbrauchsmaterialien, PSA, Arbeitskleidung und tägliche Verbrauchsprodukte.", tags: ["PSA & Sicherheit", "Verbrauchsmaterial", "Baustellenversorgung"] } },
    consultancy: { overline: "PROJEKTBERATUNG", title: "Volle Unterstützung von der Investition bis zur Übergabe",
      intro: "Für Investoren, Architekturbüros und Bauunternehmer — Expertenberatung in jeder Phase.",
      cards: [
        { title: "Machbarkeitsanalyse", desc: "Technische und finanzielle Machbarkeit, Standortanalyse und Risikobewertung vor der Investition." },
        { title: "Genehmigungen", desc: "Verwaltung von Zonierung, Baugenehmigungen und offiziellen Freigaben." },
        { title: "Leistungsverzeichnis & Ausschreibung", desc: "Ausschreibungsunterlagen und Auftragnehmerauswahl." },
        { title: "Kostenmanagement", desc: "Budgetplanung, Mengenermittlung, Abschlagskontrolle und Optimierung." },
        { title: "Rechtsberatung", desc: "Vertragsmanagement, Streitbeilegung und Compliance." },
        { title: "Projektmanagement", desc: "Planung, Koordination, Aufsicht und Übergabe — End-to-End." },
      ] },
  },
};

const deepMerge = (base, override) => {
  const out = { ...base };
  for (const k in override) {
    if (override[k] && typeof override[k] === "object" && !Array.isArray(override[k])) {
      out[k] = deepMerge(base[k] || {}, override[k]);
    } else {
      out[k] = override[k];
    }
  }
  return out;
};

Object.keys(partial).forEach((code) => {
  translations[code] = deepMerge(translations.en, partial[code]);
});

export const LANGUAGES = [
  { code: "tr", label: "Türkçe" },
  { code: "en", label: "English" },
  { code: "ar", label: "العربية" },
  { code: "bs", label: "Bosanski" },
  { code: "hr", label: "Hrvatski" },
  { code: "sr", label: "Српски" },
  { code: "ro", label: "Română" },
  { code: "de", label: "Deutsch" },
];

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "tr";
    return localStorage.getItem("demiray_lang") || "tr";
  });

  const setLang = (l) => {
    setLangState(l);
    try { localStorage.setItem("demiray_lang", l); } catch (e) {}
  };

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t: translations[lang] || translations.en }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
